/*
 * shamtam-saved.js — saved items, the wishlist (T-WISHLIST, 2026-10-29). Deferred; one delegated click listener.
 * The hearts' look is CSS (<style id="shw-state">, written in the head by snippets/shamtam-saved-head); this file
 * rewrites that style on a tap, so no card is ever touched one by one.
 *   guest      the list lives on the device: localStorage "shamtam:saved" = [{id, h}] newest first
 *   signed in  the list lives in the account: shamtam.com/apps/rings/saved (the catalog-sync worker, App Proxy);
 *              the device keeps ten minutes of taps ("shamtam:saved:o") so the next page is right at once
 * On sign-in a guest list joins the account by itself. Nothing here touches the cart (cart-stability rule).
 */
(function () {
  var S = window.__shw || { ids: [], customer: null };
  var T = {}; try { T = JSON.parse(document.getElementById('shw-t').textContent); } catch (e) {}
  var GK = 'shamtam:saved', OK = 'shamtam:saved:o';
  var get = function (k, d) { try { return JSON.parse(localStorage.getItem(k)) || d; } catch (e) { return d; } };
  var put = function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} };
  var sel = function (ids) { return ids.map(function (i) { return '[data-wl="' + i + '"]'; }).join(','); };

  function paint() {
    var st = document.getElementById('shw-state');
    if (!st) { st = document.createElement('style'); st.id = 'shw-state'; document.head.appendChild(st); }
    var L = S.ids;
    st.textContent = L.length ? sel(L) + '{--shw-f:var(--shw-fo);--shw-s:var(--shw-so)}.shw-heart--pdp:is(' + sel(L) + '){background:#33503F}.shw-count{display:block!important}.shw-count::after{content:"' + L.length + '"}' : '';
  }
  function label(b) {
    var on = S.ids.indexOf(b.getAttribute('data-wl')) > -1;
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (T.save) b.setAttribute('aria-label', on ? T.remove : T.save);
  }
  function labels() { var b = document.querySelectorAll('[data-wl]'); for (var i = 0; i < b.length; i++) label(b[i]); }

  function call(op, q) {
    var u = '/apps/rings/saved?op=' + op + '&country=' + encodeURIComponent(T.country || '') + (q || '');
    return fetch(u, { method: op === 'list' ? 'GET' : 'POST', credentials: 'same-origin', headers: { accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }

  var toasted = false;
  function toast() {
    if (toasted) return; toasted = true;
    try { if (sessionStorage.getItem('shw-toast')) return; sessionStorage.setItem('shw-toast', '1'); } catch (e) {}
    if (!T.toast || location.pathname.indexOf('/pages/saved') > -1) return;
    var d = document.createElement('div');
    d.setAttribute('role', 'status');
    d.style.cssText = 'position:fixed;z-index:9999;left:50%;bottom:20px;transform:translateX(-50%);max-width:calc(100vw - 32px);display:flex;gap:12px;align-items:center;padding:10px 16px;border-radius:10px;background:#33503F;color:#fff;font:13px/1.45 Manrope,-apple-system,sans-serif;box-shadow:0 6px 24px rgba(0,0,0,.18)';
    var t = document.createElement('span'); t.textContent = T.toast;
    var a = document.createElement('a'); a.href = T.url || '/pages/saved'; a.textContent = T.see; a.style.cssText = 'color:#D9B978;font-weight:700;white-space:nowrap';
    d.appendChild(t); d.appendChild(a); document.body.appendChild(d);
    setTimeout(function () { d.remove(); }, 4000);
  }

  function toggle(b) {
    var id = b.getAttribute('data-wl'), h = b.getAttribute('data-wl-h') || '';
    if (!id) return;
    var on = S.ids.indexOf(id) < 0;
    if (on) S.ids.unshift(id); else S.ids.splice(S.ids.indexOf(id), 1);
    paint(); labels();
    if (on) toast();
    if (!S.customer) {
      var g = get(GK, []).filter(function (x) { return String(x.id) !== id; });
      if (on) g.unshift({ id: id, h: h });
      put(GK, g.slice(0, 100));
    } else {
      var o = get(OK, {}); o[id] = { on: on, t: Date.now(), c: S.customer }; put(OK, o);
      call(on ? 'add' : 'remove', '&id=' + id).then(function (r) {
        if (r && r.signedIn && r.ids) { S.ids = r.ids.map(String); paint(); labels(); }
      }).catch(function () {});
    }
    // on the Saved page an unsaved card goes away
    var page = document.querySelector('[data-shw-page]');
    if (!on && page) {
      var card = b.closest('.shc-card');
      if (card && page.contains(card)) { card.classList.add('is-gone'); setTimeout(function () { card.remove(); empty(page); }, 300); }
    }
  }

  function empty(page) {
    var grid = page.querySelector('.shw-page__grid'), e = page.querySelector('.shw-page__empty');
    if (grid && e) e.hidden = !!grid.querySelector('.shc-card');
  }

  // the guest Saved page: each card from /products/<handle>?view=shw-card, in the device's order
  function guestPage(page) {
    var grid = page.querySelector('.shw-page__grid'), list = get(GK, []);
    if (!list.length) { empty(page); return; }
    var root = (T.url || '/pages/saved').replace(/\/pages\/saved$/, '');
    Promise.all(list.map(function (x) {
      return x.h ? fetch(root + '/products/' + encodeURIComponent(x.h) + '?view=shw-card', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; }) : '';
    })).then(function (html) {
      grid.innerHTML = html.filter(function (t) { return t.indexOf('shc-card') > -1; }).join('');
      labels(); empty(page);
    });
  }

  // a guest list made before signing in joins the account by itself, nothing to press
  function merge() {
    var g = get(GK, []);
    if (!S.customer || !g.length) return;
    call('merge', '&ids=' + g.map(function (x) { return x.id; }).join(',')).then(function (r) {
      if (!r || !r.signedIn) return;
      try { localStorage.removeItem(GK); } catch (e) {}
      var o = get(OK, {}), n = Date.now();
      r.ids.forEach(function (i) { o[i] = { on: true, t: n, c: S.customer }; });
      put(OK, o);
      S.ids = r.ids.map(String); paint(); labels();
    }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.shw-heart[data-wl]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    toggle(b);
  });
  // a card the theme re-renders (variant change, recommendations) carries the right look already; only the labels
  var idle = window.requestIdleCallback || function (f) { setTimeout(f, 200); };
  idle(function () {
    labels();
    merge();
    var page = document.querySelector('[data-shw-page]');
    if (page) { if (page.hasAttribute('data-shw-guest')) guestPage(page); else empty(page); }
    // expired taps out of the device log
    var o = get(OK, null), n = Date.now(), k, ch = false;
    if (o) { for (k in o) if (n - o[k].t > 6e5) { delete o[k]; ch = true; } if (ch) put(OK, o); }
  });
})();
